"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  IFRAME: null,
  ACTION_HOOK: null,
  CONFIRMATION_ACTION_HOOK: null
});

exports.default = _default;
module.exports = exports.default;